/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { UserMin } from '../../../constants/users';
import { Column } from '../../tracking-list';
import { ColumnCommonProps } from '../survey-question-list';

interface ColumnVerifiersProps extends ColumnCommonProps{
  users?: UserMin[];
}

export const ColumnVerifiers = (props: ColumnVerifiersProps) => {
  const { question, handleGoToQuestion, users } = props;

  const getName = (userId: string) => {
    if (!users) {
      return userId;
    }
    const user = users.find(u => u._id === userId);
    return `${user?.firstName ?? ''} ${user?.surname ?? ''}`;
  }

  const hasVerifiers = question.utrv && question.utrv?.stakeholders.verifier.length > 0;
  return (
    <Column className='pl-2 stakeholderCol' truncateTwoline onClick={handleGoToQuestion}>
      <strong>Verifiers:</strong> {hasVerifiers ? question.utrv?.stakeholders.verifier.map(u => getName(u)).join(', ') : 'none' }
    </Column>
  );
}
